// @generated by protoc-gen-es v2.12.1 with parameter "target=ts"
// @generated from file nodebase/v1/billing.proto (package nodebase.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { RequestMeta } from "./common_pb";
import { file_nodebase_v1_common } from "./common_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file nodebase/v1/billing.proto.
 */
export const file_nodebase_v1_billing: GenFile = /*@__PURE__*/
  fileDesc("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", [file_nodebase_v1_common]);

/**
 * @generated from message nodebase.v1.GetBillingStatusRequest
 */
export type GetBillingStatusRequest = Message<"nodebase.v1.GetBillingStatusRequest"> & {
  /**
   * @generated from field: nodebase.v1.RequestMeta meta = 1;
   */
  meta?: RequestMeta | undefined;

  /**
   * @generated from field: string workspace_id = 2;
   */
  workspaceId: string;
};

/**
 * Describes the message nodebase.v1.GetBillingStatusRequest.
 * Use `create(GetBillingStatusRequestSchema)` to create a new message.
 */
export const GetBillingStatusRequestSchema: GenMessage<GetBillingStatusRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_billing, 0);

/**
 * @generated from message nodebase.v1.GetBillingStatusResponse
 */
export type GetBillingStatusResponse = Message<"nodebase.v1.GetBillingStatusResponse"> & {
  /**
   * @generated from field: nodebase.v1.WorkerAccess access = 1;
   */
  access: WorkerAccess;

  /**
   * @generated from field: string worker_region = 2;
   */
  workerRegion: string;

  /**
   * Whether this deployment sells subscriptions at all.
   *
   * @generated from field: bool billing_enabled = 3;
   */
  billingEnabled: boolean;

  /**
   * A paid slot is free in worker_region right now.
   *
   * @generated from field: bool slot_available = 4;
   */
  slotAvailable: boolean;

  /**
   * The owner asked for a slot while the region was full.
   *
   * @generated from field: bool interest_recorded = 5;
   */
  interestRecorded: boolean;

  /**
   * The owner has a processor customer, so the self-service portal can open.
   *
   * @generated from field: bool manage_available = 6;
   */
  manageAvailable: boolean;

  /**
   * @generated from field: int64 current_period_end_unix = 7;
   */
  currentPeriodEndUnix: bigint;

  /**
   * @generated from field: bool cancel_at_period_end = 8;
   */
  cancelAtPeriodEnd: boolean;

  /**
   * @generated from field: int64 grace_until_unix = 9;
   */
  graceUntilUnix: bigint;

  /**
   * @generated from field: string price_label = 10;
   */
  priceLabel: string;

  /**
   * Payments run against the processor's test environment.
   *
   * @generated from field: bool test_mode = 11;
   */
  testMode: boolean;
};

/**
 * Describes the message nodebase.v1.GetBillingStatusResponse.
 * Use `create(GetBillingStatusResponseSchema)` to create a new message.
 */
export const GetBillingStatusResponseSchema: GenMessage<GetBillingStatusResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_billing, 1);

/**
 * @generated from message nodebase.v1.CreateCheckoutSessionRequest
 */
export type CreateCheckoutSessionRequest = Message<"nodebase.v1.CreateCheckoutSessionRequest"> & {
  /**
   * @generated from field: nodebase.v1.RequestMeta meta = 1;
   */
  meta?: RequestMeta | undefined;

  /**
   * @generated from field: string workspace_id = 2;
   */
  workspaceId: string;
};

/**
 * Describes the message nodebase.v1.CreateCheckoutSessionRequest.
 * Use `create(CreateCheckoutSessionRequestSchema)` to create a new message.
 */
export const CreateCheckoutSessionRequestSchema: GenMessage<CreateCheckoutSessionRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_billing, 2);

/**
 * @generated from message nodebase.v1.CreateCheckoutSessionResponse
 */
export type CreateCheckoutSessionResponse = Message<"nodebase.v1.CreateCheckoutSessionResponse"> & {
  /**
   * @generated from field: string url = 1;
   */
  url: string;

  /**
   * @generated from field: int64 expires_unix = 2;
   */
  expiresUnix: bigint;
};

/**
 * Describes the message nodebase.v1.CreateCheckoutSessionResponse.
 * Use `create(CreateCheckoutSessionResponseSchema)` to create a new message.
 */
export const CreateCheckoutSessionResponseSchema: GenMessage<CreateCheckoutSessionResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_billing, 3);

/**
 * @generated from message nodebase.v1.CreateBillingPortalSessionRequest
 */
export type CreateBillingPortalSessionRequest = Message<"nodebase.v1.CreateBillingPortalSessionRequest"> & {
  /**
   * @generated from field: nodebase.v1.RequestMeta meta = 1;
   */
  meta?: RequestMeta | undefined;

  /**
   * @generated from field: string workspace_id = 2;
   */
  workspaceId: string;
};

/**
 * Describes the message nodebase.v1.CreateBillingPortalSessionRequest.
 * Use `create(CreateBillingPortalSessionRequestSchema)` to create a new message.
 */
export const CreateBillingPortalSessionRequestSchema: GenMessage<CreateBillingPortalSessionRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_billing, 4);

/**
 * @generated from message nodebase.v1.CreateBillingPortalSessionResponse
 */
export type CreateBillingPortalSessionResponse = Message<"nodebase.v1.CreateBillingPortalSessionResponse"> & {
  /**
   * @generated from field: string url = 1;
   */
  url: string;
};

/**
 * Describes the message nodebase.v1.CreateBillingPortalSessionResponse.
 * Use `create(CreateBillingPortalSessionResponseSchema)` to create a new message.
 */
export const CreateBillingPortalSessionResponseSchema: GenMessage<CreateBillingPortalSessionResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_billing, 5);

/**
 * WorkerAccess is derived on every read from grants and the mirrored
 * subscription; it is never stored.
 *
 * @generated from enum nodebase.v1.WorkerAccess
 */
export enum WorkerAccess {
  /**
   * @generated from enum value: WORKER_ACCESS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * A free grant: invited, pre-billing, or granted by an operator.
   *
   * @generated from enum value: WORKER_ACCESS_INCLUDED = 1;
   */
  INCLUDED = 1,

  /**
   * @generated from enum value: WORKER_ACCESS_SUBSCRIBED = 2;
   */
  SUBSCRIBED = 2,

  /**
   * A renewal failed; the Worker keeps running until grace_until_unix.
   *
   * @generated from enum value: WORKER_ACCESS_PAST_DUE = 3;
   */
  PAST_DUE = 3,

  /**
   * Subscribed before, no longer entitled.
   *
   * @generated from enum value: WORKER_ACCESS_LAPSED = 4;
   */
  LAPSED = 4,

  /**
   * Never entitled: a Worker needs a subscription.
   *
   * @generated from enum value: WORKER_ACCESS_REQUIRED = 5;
   */
  REQUIRED = 5,
}

/**
 * Describes the enum nodebase.v1.WorkerAccess.
 */
export const WorkerAccessSchema: GenEnum<WorkerAccess> = /*@__PURE__*/
  enumDesc(file_nodebase_v1_billing, 0);

/**
 * BillingService answers "may this Workspace run a Worker, and if not, how
 * does its owner get one" (docs/paid-worker-signup.md). Payment happens on the
 * processor's hosted pages; these RPCs only hand out their URLs.
 *
 * @generated from service nodebase.v1.BillingService
 */
export const BillingService: GenService<{
  /**
   * @generated from rpc nodebase.v1.BillingService.GetBillingStatus
   */
  getBillingStatus: {
    methodKind: "unary";
    input: typeof GetBillingStatusRequestSchema;
    output: typeof GetBillingStatusResponseSchema;
  },
  /**
   * CreateCheckoutSession reserves one paid slot in the Workspace's region and
   * returns the hosted payment page. A full region answers with the
   * paid-capacity-full reason and records the owner's interest instead.
   *
   * @generated from rpc nodebase.v1.BillingService.CreateCheckoutSession
   */
  createCheckoutSession: {
    methodKind: "unary";
    input: typeof CreateCheckoutSessionRequestSchema;
    output: typeof CreateCheckoutSessionResponseSchema;
  },
  /**
   * CreateBillingPortalSession opens the processor's self-service page for an
   * owner who has subscribed before: card, invoices, cancellation.
   *
   * @generated from rpc nodebase.v1.BillingService.CreateBillingPortalSession
   */
  createBillingPortalSession: {
    methodKind: "unary";
    input: typeof CreateBillingPortalSessionRequestSchema;
    output: typeof CreateBillingPortalSessionResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_nodebase_v1_billing, 0);

